import ModalLinkController from "../../../../javascript/stimulusControllers/modals/modal-link-controller";

export default class extends ModalLinkController {
  openActivityForm() {}

  get requestURL() {
    return this.data.get("new-activity-url");
  }
};



// WEBPACK FOOTER //
// ./app/components/buttons/assets/javascript/buttons-add-activity-modal-button-controller.js